module.exports = {"330727100":"安文镇","330727101":"新渥镇","330727102":"尖山镇","330727103":"仁川镇","330727104":"大盘镇","330727105":"方前镇","330727106":"玉山镇","330727107":"尚湖镇","330727108":"冷水镇","330727200":"深泽乡","330727201":"双峰乡","330727203":"双溪乡","330727205":"窈川乡","330727206":"盘峰乡","330727207":"高二乡","330727208":"维新乡","330727209":"胡宅乡","330727210":"万苍乡","330727211":"九和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330727.json
// module id = 922
// module chunks = 0